//not using for 7/15 keeping this for backup can be removed later 




import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
    private apiUrl = environment.API_URL; 
  private total: number = 0;
  private planId: number = 0;
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    
  ) {}

  submitOrder(orderData: any): Observable<any> {
    const token = this.authService.getToken();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.http.put(`${this.apiUrl}/nexusapi/add_customer`, orderData, { headers });
  }

  checkCoverage(zipcode: String): Observable<any> {
   
   

    return this.http.post(`${this.apiUrl}/mobileapi/zipcode/${zipcode}/eligibility`,
      zipcode);
  }
  setOrderDetails(total: number, planId: any) {
    this.total = total;
    this.planId = planId;
  }

  getTotal(): number {
    return this.total;
  }

  getPlanId(): number {
    return this.planId;
  }
}